import { store } from '../../../../lib/store'
const __batchSize__ = 16

const TILE_CACHE_MAX = 512

class DownloadManager {
  constructor() {
    this.basemapTiles = []
    this.auth = null
    this.mapInstance = null
    this.overlays = []
    this.downloading = {
      id: null,
      tiles: []
    }
    this.tileCache = new Map()
  }

  addBasemapTile({ needsAuth, tile, url, zoom, name, drawOrder }) {
    this.basemapTiles.push({ needsAuth, tile, url, zoom, name, drawOrder })
    if (this.downloading.id === null) {
      this.download()
    }
  }

  addOverlayTile({ id, tile, url, zoom, drawOrder }) {
    const overlaySet = this.overlays.find(set => set.layerId === id && set.zoom === zoom)
    if (overlaySet) {
      overlaySet.tiles.push({ needsAuth: true, tile: tile, url: url, drawOrder })
    } else {
      this.overlays.push({ layerId: id, zoom: zoom, tiles: [{ needsAuth: true, tile: tile, url: url, drawOrder }] })
    }
    if (this.downloading.id === null) {
      this.download()
    }
  }

  wrapRequest(tileObj) {
    if (this.tileCache.has(tileObj.url)) {
      return new Promise(resolve => {
        tileObj.tile.src = this.tileCache.get(tileObj.url)
        tileObj.tile.style.display = 'block'
        tileObj.tile.setAttribute('drawOrder', tileObj.drawOrder)
        resolve()
      })
    }

    return new Promise(resolve => {
      const fetchImage = new XMLHttpRequest()

      fetchImage.open('GET', tileObj.url)
      if (tileObj.needsAuth) {
        fetchImage.setRequestHeader('Authorization', `Bearer ${this.auth}`)
        fetchImage.setRequestHeader('Content-Type', 'image/png')
        fetchImage.setRequestHeader('Platform', 'Web')
        fetchImage.setRequestHeader('Version', `${__version__}`)
      }
      fetchImage.responseType = 'arraybuffer'
      fetchImage.onload = function (e) {
        const blob = new Blob([fetchImage.response], { type: 'image/png' })
        const blobUrl = URL.createObjectURL(blob)
        if (this.tileCache.size >= TILE_CACHE_MAX) {
          const oldest = this.tileCache.keys().next().value
          URL.revokeObjectURL(this.tileCache.get(oldest))
          this.tileCache.delete(oldest)
        }
        this.tileCache.set(tileObj.url, blobUrl)
        tileObj.tile.src = blobUrl
        tileObj.tile.style.display = 'block'
        tileObj.tile.setAttribute('drawOrder', tileObj.drawOrder)
        resolve()
      }.bind(this)
      fetchImage.send()
    })
  }

  cullTiles() {
    const currZoom = this.mapInstance.getZoom()
    if (currZoom) {
      this.basemapTiles = this.basemapTiles.filter(tileSet => tileSet.zoom === currZoom &&
        tileSet.name === this.mapInstance.mapTypeId)
      this.overlays = this.overlays.filter(tileSet => tileSet.zoom === currZoom)
    }
  }

  download() {
    if (this.basemapTiles.length === 0 && this.overlays.length === 0) {
      google.maps.event.trigger(this.mapInstance, 'tilesloaded')
      return
    }
    this.auth = store.getState().auth.token
    this.mapInstance = store.getState().mapReference()
    if (this.basemapTiles.length > 0) {
      this.downloading.id = 'basemap'
      for (let i = 0; i < __batchSize__; ++i) {
        const tile = this.basemapTiles.shift()
        if (tile) {
          this.downloading.tiles.push(this.wrapRequest(tile))
        }
      }
    } else if (this.overlays.length > 0) {
      const set = this.overlays[0]
      this.downloading.id = set.id
      for (let i = 0; i < __batchSize__; ++i) {
        const tile = set.tiles.shift()
        if (tile) {
          this.downloading.tiles.push(this.wrapRequest(tile))
        }
      }
      if (set.tiles.length === 0) {
        this.overlays.shift()
      }
    }
    Promise.all(this.downloading.tiles).then(() => {
      this.downloading.id = null
      this.downloading.tiles = []
      this.download()
    })
  }

  setOptions(mapInstance) {
    this.mapInstance = mapInstance

    google.maps.event.addListener(this.mapInstance, 'idle', () => {
      this.cullTiles()
    })
  }
}

const Manager = new DownloadManager()

export const setDownloaderOptions = Manager.setOptions.bind(Manager),
  addBasemapTile = Manager.addBasemapTile.bind(Manager),
  addOverlayTile = Manager.addOverlayTile.bind(Manager)
